
// "use strict";

$(document).ready(function(){
    
    var slShopify = window.Shopify;
    console.log('slShopify',slShopify);

    var advanceCartDiscountConditions;
    var cartOriginalGrandTotal = 0;
    var cartDiscountConditionValid = 0;
    var discountValueOneTime = 0;
    var discountValueSubscription  = 0.15;
    var cartItems;

    var upsellAddToCart = $('.upsell-add-to-cart');
    var upsellProductsWrapper = $('.upsell-products-wrapper');
    var upsellProductsLoaderContainer = $('.upsell-products-loader-container');
    var upsellProductsContainer = $('.upsell-products-container');
    var upsellProductHTML = '';
    var upSellDataRaw;
    var upSellHandle = upsellProductsWrapper.attr('data-handle');

    var upSellProductAddedTitle = $('h1').html();
    var upSellVariationSelector = $('#ProductSelect-product-shinyleaf');
    var upSellQuantitySelector = $('#Quantity-product-shinyleaf select');
    var upSellProductAddedImage = $('.shinyleaf-product-real-images img').first().attr('data-mfp-src');
    var totalLineItemQuantity = 0;

    var currentFixedPercentageRules = {};

    // Set Default if not set
    if (getCookie('discount_code') == null || getCookie('discount_code') == "") {
        setCookie('discount_code','DEFAULT10',999);
    }


    // Selling Plan - Rules
    var sellingPlans = [];
    sellingPlans["1"] = 2912878818;
    sellingPlans["2"] = 2912911586;
    sellingPlans["3"] = 2912944354;
    sellingPlans["6"] = 2912977122;
    sellingPlans["12"] = 2913009890;
    console.warn('sellingPlans',sellingPlans);

    var enableSealSubscription = true;
    var withSubscriptionProducts = false;
  

    /*
    * Shipping Protection
    * 2020-09-04
    */
    var shippingProtection = localStorage.getItem('shipping_protection');
    var shippingProtectStatus = false;

    if (shippingProtection) {
        if (shippingProtection == 'yes') {
            shippingProtectStatus = true;
        }
    }

    if (upSellVariationSelector.find('option').length > 1){
        $('body').addClass('page-multiple-variations');
    }else{
        $('body').addClass('page-single-variation');
    }

    $(document).on('change click blur', '#ProductSelect-product-shinyleaf', function () {
        var variantPrice = $(this).find('option:selected').attr('data-price');
        console.log(variantPrice);
        $('.upsell-add-to-cart').attr('data-item-price', variantPrice );
        recheckButtonPrice();
    });

    $(document).on('change click blur', '.sl-custom-purchase-type', function () {
        recheckButtonPrice();
    });

    $(document).on('change click blur', '#Quantity-product-shinyleaf select', function () {
        recheckButtonPrice();
    });

    function recheckButtonPrice(){

        var price = upsellAddToCart.attr('data-item-price');
        price = price / 100;

        price = price * $('#Quantity-product-shinyleaf select').val();
        price = price.toFixed(2);
        
        // Floating
        $('.sl-floating-add-to-cart-button .price').html(slCurrencySymbol + price);

        var discountedPrice = (price * discountValueSubscription);
        var saveNotesAmount = discountedPrice;
        saveNotesAmount = saveNotesAmount.toFixed(2);

        var discountedAmount = price - saveNotesAmount;
        discountedAmount = discountedAmount.toFixed(2);

        $('.save-notes-container').show();

        // Product Option for Mobile Version
        $('.sl-0217-price-onetime').html(slCurrencySymbol + price);
        $('.sl-0217-price-subscription').html(slCurrencySymbol + discountedAmount);

        if ($('.sl-custom-purchase-type:checked').val() == 'onetime') {

            if ($('.utm-get-discount-container').length){
                console.warn('.utm-get-discount-container is available');
            }else{
                console.warn('.utm-get-discount-container is not available');
            }

            $('body').removeClass('product-type-subscription').addClass('product-type-one-time');
            upsellAddToCart.html('ADD TO CART <span class="unicode">|</span> <span class="amount">' + slCurrencySymbol + price + '</span>');
            // $('.save-notes-container').html('Or, Save <span class="amount">' + slCurrencySymbol + saveNotesAmount + '</span> with Recurring delivery!');
            $('.save-notes-container').html('Or, Save 15% with Recurring delivery!');

            
            
        } else {

            $('body').removeClass('product-type-one-time').addClass('product-type-subscription');
            upsellAddToCart.html('ADD TO CART <span class="unicode">|</span> <span class="amount">' + slCurrencySymbol + discountedAmount + '</span>');
            // $('.save-notes-container').html('Congratulations! You Will Save <span class="amount amount-success">' + slCurrencySymbol + saveNotesAmount + '</span>.');
            $('.save-notes-container').html('Congratulations! You Will Save 15%.');

            
        }
    }

    
    $('.shopify-product-form').submit(function(e){
        return false;
    });


    $( document ).ajaxComplete(function( event, xhr, settings ) {
        var endPointURL = settings.url;
        var substring = 'https://app.shinyleafcosmetics.com?advanced_cart_discounts=init';
        if (endPointURL.indexOf(substring) !== -1){

            console.warn('Completed: ' + endPointURL);
            console.warn('Discount Data - Ready');

        }
    });


    



    // Clone Original Add To Cart
    console.warn('Preparing Upsell Upsell');
    console.warn('Preparing Upsell Button');
    

    upsellAddToCart.html('WAIT A SEC...');


    

    // Pull The Upsell - March 19
    $(window).on('load',function(){

        // console.log('window.Shopify.rate',window.Shopify.rate);
        $.get('https://app.shinyleafcosmetics.com/?upsell_data=product-variants&handle=' + upSellHandle, function (response) {
            upSellDataRaw = response;
            recheckButtonPrice();
            upsellAddToCart.addClass('upsell-add-to-cart-ready');

            $('body').addClass('upsell-module-is-ready');

            console.warn('Upsell Data - Ready');
            console.warn('Upsell Button - Ready');

            // Add to cart hash
            if(window.location.hash && window.location.hash == '#add-to-cart') {
                $('.upsell-add-to-cart').click();
            }

        });
    });

    $(document).on('click', '.upsell-add-to-cart', function(e){
   
        console.log('>>.upsell-add-to-cart CLICKED!');
        
        var optionalText = '';
        
        e.preventDefault();
        
        upsellAddToCart.html('PLEASE WAIT...');

        if ($(this).hasClass('upsell-add-to-cart-ready')){
            
            console.log('>>.upsell-add-to-cart purchased type: ' + $('.sl-custom-purchase-type:checked').val());

            if ($('.sl-custom-purchase-type:checked').val() == 'onetime' ){

                var addedProductData = {
                    id: upSellVariationSelector.val(),
                    quantity: upSellQuantitySelector.val()
                };
                
                ga('send', 'event', 'Shiny Leaf Upsell', 'Click', 'Add To Cart');


            }else{

                var addedProductData = {
                    id: upSellVariationSelector.val(),
                    quantity: upSellQuantitySelector.val(),
                    properties: {
                        subscription_id: 213870,
                        shipping_interval_unit_type: 'Months',
                        shipping_interval_frequency: $('.sl-custom-auto-deliver').val(),
                    }
                };


                // Seal Subscription Override
                // if (enableSealSubscription && upSellHandle == 'enhairgy'){
                if (enableSealSubscription){
                    var selectedMonth = $('.sl-custom-auto-deliver').val();
                    addedProductData.properties = {};
                    addedProductData.selling_plan = sellingPlans[selectedMonth];

                    withSubscriptionProducts = true;
                }

                
                optionalText = 'Recurring Delivery every ' + $('.sl-custom-auto-deliver').val() + ' Months. ';
                optionalText+= '<br><strong>Subscription discounts</strong> will be added at the Cart Page.';

                ga('send', 'event', 'Shiny Leaf Upsell', 'Click', 'Add To Cart RC');
            }

            
             // Reddit
             if (typeof rdt === 'function') {

                var rdtPrice = upsellAddToCart.attr('data-item-price');
                rdtPrice = rdtPrice / 100;

                rdtPrice = rdtPrice * $('#Quantity-product-shinyleaf select').val();
                rdtPrice = rdtPrice.toFixed(2);

                var rdtPayload = {
                    "currency": "USD",
                    "itemCount": upSellQuantitySelector.val(),
                    "value": rdtPrice,
                    "products": [
                        {
                            "id": upSellVariationSelector.val(),
                            "name": $('[property="og:title"]').attr('content')
                        },
                    ]
                };
                console.log('rdtPayload',rdtPayload);
                rdt('track', 'AddToCart', rdtPayload);
            }

            
            $.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: addedProductData,
                dataType: 'json',
                success: function (response) {

                    try {
                        window.stop();
                    } catch (exception) {
                        document.execCommand('Stop');
                    }
                    
                    recheckButtonPrice();
                    openUpSellPopup(optionalText);
                    
                },
                error : function (response) {

                    console.log(response);

                }
            });

        }

    });

    function openUpSellPopup(optionalText){

        var selectedVariantTitle = upSellVariationSelector.find('option:selected').html().trim();
        if (selectedVariantTitle == 'Default Title') {
            selectedVariantTitle = '';
        }

        console.log('>>.upsell-add-to-cart variant title: ' + selectedVariantTitle);

        var cartOriginalGrandTotal = 0;
        var itemCount = 0;

        upsellProductsLoaderContainer.fadeIn();

        var upSellData = $.parseJSON(upSellDataRaw);
        console.log(upSellData);

        var products = upSellData.upsell_products;

        upSellProductAddedImage = $('.full-detail-sidebar-content').find('img').attr('src');



        // Upsell Images
        var productAddedVariantID = upSellVariationSelector.val();
        var productAddedVariantImage = upsellThumbnails[productAddedVariantID];
        upSellProductAddedImage = productAddedVariantImage;
        console.warn('Variant Added ID = ' + productAddedVariantID);
        console.warn('Variant Added Image = ' + productAddedVariantImage);


        upsellProductsContainer.html('');

        // upsellProductsContainer.append('<h2>Frequently bought with ' + upSellData.handle + '.</h2>');
        upsellProductHTML = '';


        upsellProductHTML += '<div class="upsell-mobile-only"></div>';
        
        upsellProductHTML += '<div class="upsell-added-product">';
        upsellProductHTML += '<div class="row">';

        upsellProductHTML += '<div class="col-4 col-md-3 my-auto">';
        upsellProductHTML += '<div class="image">';
        upsellProductHTML += '<img class="img-fluid" src="' + upSellProductAddedImage + '"/>';
        upsellProductHTML += '</div>';
        upsellProductHTML += '</div>';

        upsellProductHTML += '<div class="col-8 col-md-5 my-auto">';
        upsellProductHTML += '<div class="text">';
        upsellProductHTML += '<h2>YOU JUST ADDED</h2>';
        upsellProductHTML += '<p><span class="upsell-added-product-quantity">' + upSellQuantitySelector.val() + ' x</span> ' + upSellProductAddedTitle + ' ' + selectedVariantTitle + '</p>';

        if (optionalText != ''){
            upsellProductHTML += '<small class="optional-text">' + optionalText + '</small>';
        }
        
        
        
        upsellProductHTML += '<p class="upsell-sub-total-label">Cart Subtotal: <span class="upsell-subtotal">' + slCurrencySymbol + cartOriginalGrandTotal + '</span></p>';
        upsellProductHTML += '<p class="upsell-total-quantity-label" data-item-count="' + itemCount + '">(' + itemCount + ' items)</p>';
        
        upsellProductHTML += '</div>';
        upsellProductHTML += '</div>';


        upsellProductHTML += '<div class="col-md-4 my-auto">';
        upsellProductHTML += '<div class="summary">';

        // Discount Code Details
        if ($('.utm-get-discount-container').length){
            upsellProductHTML += '<div class="upsell-discount-code-details utm-get-discount-container">';
            upsellProductHTML += $('.utm-get-discount-container').html();
            upsellProductHTML += '</div>';
        }
        
        upsellProductHTML += '<div class="upsell-action">';


        upsellProductHTML += '<div class="upsell-action-summary">';
        upsellProductHTML += '<p class="upsell-sub-total-label">Cart Subtotal: <span class="upsell-subtotal">' + slCurrencySymbol + cartOriginalGrandTotal + '</span></p>';
        upsellProductHTML += '<p class="upsell-total-quantity-label" data-item-count="' + itemCount + '">(' + itemCount + ' items)</p>';
        upsellProductHTML += '</div>';


        upsellProductHTML += '<button type="button" class="upsell-cart-link">PROCEED TO CHECKOUT</button>';
        // upsellProductHTML += '<button type="button" class="upsell-continue-link">CONTINUE SHOPPING</button>';
        upsellProductHTML += '</div>';

        upsellProductHTML += '</div>';
        upsellProductHTML += '</div>';



        upsellProductHTML += '</div>';
        upsellProductHTML += '</div>';

        
        upsellProductHTML += '<h3>Frequently Bought Together with <span class="fbt-with-product">' + upSellProductAddedTitle + '</span></h3>';


        $.each(products, function (index, product) {
            
            var upsellProductIDClass = ' upsell-product-' + product.id + '-container';

            var upsellProductClass = '';
            upsellProductClass += upsellProductIDClass;

            var upsellProductVariants = product.variants;
            var upsellProductVariantsSoldOut = 0;
            var upsellProductVariantPrice = 0;

            if (upsellProductVariants.length == 1) {
                upsellProductClass += ' single-variant-product';
            }

            if (upsellProductVariants.length > 1) {
                upsellProductClass += ' multiple-variants-product';
            }

            upsellProductHTML += '<div data-index="' + index + '" class="container-fluid upsell-product-container ' + upsellProductClass + '">';

            upsellProductHTML += '<div class="row">';   

            var productDefaultImageURL = product.images[0].src;

            if (typeof otherProductDetails[product.handle] !== 'undefined'){
                if (typeof otherProductDetails[product.handle]['defaultImage'] !== 'undefined'){
                    productDefaultImageURL = otherProductDetails[product.handle]['defaultImage'];
                }
            }

            console.warn('First Variant');
            console.warn(upsellProductVariants[0].id);

            productDefaultImageURL = upsellThumbnails[upsellProductVariants[0].id];

            upsellProductHTML += '<div class="col-4 col-md-3 my-auto">';
            upsellProductHTML += '<div class="image"><a href="https://www.shinyleaf.com/products/' + product.handle + '"><img class="img-fluid" src="' + productDefaultImageURL + '"/></a></div>';
            upsellProductHTML += '</div>';

            upsellProductHTML += '<div class="col-8 col-md-9 my-auto">';


            // Row for title and action
            upsellProductHTML += '<div class="row">';
            upsellProductHTML += '<div class="col-md-8 my-auto">';

            var upSellProductTitle = product.title;
            upsellProductHTML += '<div class="title"><a href="https://www.shinyleaf.com/products/' + product.handle + '">' + upSellProductTitle + '</a></div>';


            // Variation (If applicable)
            upsellProductHTML += '<div class="row row-variation">';

            upsellProductHTML += '<div class="col-5 my-auto">';

            // 5784510955681 - Shampoo Brush
            if (product.id == '5784510955681') {
                upsellProductHTML += '<div class="variation-label">Choose Color:</div>';
            }else{
                upsellProductHTML += '<div class="variation-label">Select Size:</div>';
            }
            upsellProductHTML += '</div>';
            

            upsellProductHTML += '<div class="col-7 my-auto">';
            upsellProductHTML += '<div class="variation-selector">';
            upsellProductHTML += '<select name="variant" class="form-control">';

            $.each(upsellProductVariants, function (index, variant) {

                if (variant.inventory_quantity > 0) {
                    upsellProductHTML += '<option data-inventory="' + variant.inventory_quantity + '" data-price="' + variant.price + '" value="' + variant.id + '" data-image="' + upsellThumbnails[variant.id] + '">' + variant.title + '</option>';

                    // Check if there is variant price set
                    if (upsellProductVariantPrice == 0) {
                        upsellProductVariantPrice = variant.price;
                    }

                } else {
                    upsellProductHTML += '<option data-inventory="0" disabled data-price="' + variant.price + '" value="' + variant.id + '">' + variant.title + ' - SOLD OUT</option>';
                    upsellProductVariantsSoldOut++;
                }

            });

            var upsellProductVariationAvailableForSale = true;
            if (upsellProductVariantsSoldOut == upsellProductVariants.length) {
                upsellProductVariationAvailableForSale = false;
            }

            
            // March 18, 2024
            if (slShopify.currency.active !== 'USD'){
                var slCurrencyRate = slShopify.currency.rate;
                console.warn('slCurrencyRate',slCurrencyRate);
                upsellProductVariantPrice = upsellProductVariantPrice * slCurrencyRate;
                console.warn('March 18 2024 - upsellProductVariantPrice',upsellProductVariantPrice);

                upsellProductVariantPrice = upsellProductVariantPrice.toFixed(2);
            }

            upsellProductHTML += '</select>';
            upsellProductHTML += '</div>';
            upsellProductHTML += '</div>';

            upsellProductHTML += '</div>';


            upsellProductHTML += '<div class="upsell-custom-purchase-options-container">';
            upsellProductHTML += '        <label><input name="upsell-purchase-option[' + product.id + ']" class="upsell-custom-purchase-type" type="radio" value="onetime" checked="">Order just this once</label>';
            upsellProductHTML += '        <label class="upsell-purchase-type-auto-deliver">';
            upsellProductHTML += '        <input name="upsell-purchase-option[' + product.id + ']" class="upsell-custom-purchase-type" type="radio" value="autodeliver">Get it delivered every';
            upsellProductHTML += '        <select class="upsell-custom-auto-deliver">';
            upsellProductHTML += '            <option value="1">1 Month</option>';
            upsellProductHTML += '            <option value="2">2 Months</option>';
            upsellProductHTML += '            <option value="3">3 Months</option>';
            upsellProductHTML += '            <option value="6">6 Months</option>';
            upsellProductHTML += '            <option value="12">12 Months (1 Year)</option>';
            upsellProductHTML += '        </select>';
            upsellProductHTML += '    </label>';
            upsellProductHTML += '    <small class="upsell-subscription-save-15">Save 15% OFF!</small>';
            upsellProductHTML += '</div>';


            if (upsellProductVariationAvailableForSale) {
                upsellProductHTML += '<div class="row row-price">';

                upsellProductHTML += '<div class="col-5 my-auto">';
                upsellProductHTML += '<div class="quantity">';
                upsellProductHTML += 'Quantity: <select name="quantity" class="form-control">';
                upsellProductHTML += '<option value="1">1</option>';
                upsellProductHTML += '<option value="2">2</option>';
                upsellProductHTML += '<option value="3">3</option>';
                upsellProductHTML += '<option value="4">4</option>';
                upsellProductHTML += '<option value="5">5</option>';
                upsellProductHTML += '<option value="6">6</option>';
                upsellProductHTML += '<option value="7">7</option>';
                upsellProductHTML += '<option value="8">8</option>';
                upsellProductHTML += '<option value="9">9</option>';
                upsellProductHTML += '<option value="10">10</option>';
                upsellProductHTML += '</select>';
                upsellProductHTML += '</div>';
                upsellProductHTML += '</div>';

                upsellProductHTML += '<div class="col-7 my-auto">';
                upsellProductHTML += '<div class="price"><span>Price:</span> <strong>' + slCurrencySymbol + upsellProductVariantPrice + '</strong></div>';
                upsellProductHTML += '</div>';

                upsellProductHTML += '</div>';
            }

            upsellProductHTML += '</div>'; // end col-md-8


            upsellProductHTML += '<div class="col-md-4 my-auto">';

            if (upsellProductVariationAvailableForSale) {
                upsellProductHTML += '<div class="action"><button data-revy-upsell-form-added="false" type="button" class="btn btn-block btn-xs btn-add-to-order">Add to Order</button></div>';
            } else {
                upsellProductHTML += '<div class="action"><button type="button" class="btn btn-block btn-xs btn-sold-out">SOLD OUT</button></div>';
            }

            upsellProductHTML += '</div>'; // end col-md-4

            upsellProductHTML += '</div>'; // end row
            upsellProductHTML += '</div>';


            upsellProductHTML += '</div>';
            upsellProductHTML += '</div>';

        });

        upsellProductsContainer.append(upsellProductHTML);
        $('.upsell-cart-link').html('UPDATING YOUR CART...').addClass('upsell-updating-cart');
        $('.upsell-discount-code-details').hide();



        // Mascara Brush
        if (jQuery('.upsell-product-5368152752289-containerx').length) {
            if (!jQuery('.product-color-picker-container').length) {
                var htmlMascaraBrush = '';
                htmlMascaraBrush += '<div class="product-color-picker-container">';
                htmlMascaraBrush += ' <p>Choose color:</p>';
                htmlMascaraBrush += ' <div class="product-mascara-brush">';
                // htmlMascaraBrush += '     <div data-color="Black" class="product-color-picker product-color-picker-black product-color-picker-selected"><div></div></div>';
                
                // htmlMascaraBrush += '     <div data-color="Pink" class="product-color-picker product-color-picker-red"><div></div></div>';
                htmlMascaraBrush += '     <div data-color="Blue" class="product-color-picker product-color-picker-blue"><div></div></div>';
                htmlMascaraBrush += '     <div data-color="Turquoise" class="product-color-picker product-color-picker-turq"><div></div></div>';
                htmlMascaraBrush += ' </div>';
                htmlMascaraBrush += ' <p>Select size:</p>';
                htmlMascaraBrush += ' <div class="product-mascara-brush-size">';
                htmlMascaraBrush += '     <select name="mascara_brush_size" class="form-control">';
                htmlMascaraBrush += '        <option value="30">30 Pack</option>';
                htmlMascaraBrush += '        <option value="7">7 Pack</option>';
                htmlMascaraBrush += '        <option value="14">14 Pack</option>';
                htmlMascaraBrush += '        <option value="50">50 Pack</option>';
                htmlMascaraBrush += '        <option value="100">100 Pack</option>';
                htmlMascaraBrush += '     </select>';
                htmlMascaraBrush += ' </div>';
                htmlMascaraBrush += '</div>';

                jQuery('.upsell-product-5368152752289-container .title').after(htmlMascaraBrush);

                selectMascaraVariant();

                jQuery(document).on('click', '.upsell-product-5368152752289-container .product-color-picker', function () {
                    jQuery('.upsell-popup .upsell-product-5368152752289-container .product-color-picker').removeClass('product-color-picker-selected');
                    jQuery(this).addClass('product-color-picker-selected');
                    selectMascaraVariant();
                });

                jQuery(document).on('change blur', '.upsell-product-5368152752289-container select[name="mascara_brush_size"]', function () {
                    selectMascaraVariant();
                });

                function selectMascaraVariant() {
                    var brushPack = jQuery('.upsell-popup .upsell-product-5368152752289-container select[name="mascara_brush_size"] option:selected').text();
                    var brushColor = jQuery('.upsell-popup .upsell-product-5368152752289-container .product-color-picker-selected').attr('data-color');
                    var brushVariantText = brushPack + ' - ' + brushColor;
                    console.warn('Brush Variant: ' + brushVariantText);
                    jQuery('.upsell-popup .upsell-product-5368152752289-container .variation-selector select option:contains("' + brushVariantText + '")').prop('selected', true);
                    jQuery('.upsell-popup .upsell-product-5368152752289-container .variation-selector select').trigger('change');
                }
            }
        }


        // Hide If Sold Out
        $('.upsell-product-container .btn-sold-out').each(function(){
            $(this).parents('.upsell-product-container').hide();
        });


        console.log('>>.upsell-add-to-cart magnific opening');

        // Open directly via API
        $.magnificPopup.open({
            items: {
                src: '<div class="upsell-popup">' + upsellProductsContainer.html() + '</div>', // can be a HTML string, jQuery object, or CSS selector
                type: 'inline'
            },
            // closeOnBgClick: false,
            callbacks: {
                open: function () {
                    // recomputeCart();
                    console.log('>>.upsell-add-to-cart magnific callbak -> checkDiscountCodeBeforeRecompute()!');
                    checkDiscountCodeBeforeRecompute();

                },
                close: function () {
                    // Will fire when popup is closed

                    ga('send', 'event', 'Shiny Leaf Upsell', 'Click', 'Close Popup');

                    // set defaul type
                    $('.sl-custom-purchase-type[value="onetime"]').click();
                    
                }
                // e.t.c.
            }
        });

        upsellProductsWrapper.addClass('active');
        upsellProductsLoaderContainer.fadeOut();
    }


    $(document).on('click', '.btn-upsell-add-premium-membership', function (e) {
        e.preventDefault();

        var thisButton = $(this);

        if (!thisButton.hasClass('btn-added')) {
            thisButton.html('PLEASE WAIT...');
            subscribeToPremiumMembership();
        }

    });

    function subscribeToPremiumMembership() {

        $('.upsell-cart-link').html('UPDATING YOUR CART...').addClass('upsell-updating-cart');
        var premiumMembershipData = {
            id: 30706032345220,
            quantity: 1,
            properties: {
                subscription_id: "221487",
                shipping_interval_unit_type: "Months",
                shipping_interval_frequency: "12",
            }
        };

        // Adding Premium Membership
        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: premiumMembershipData,
            dataType: 'json',
            success: function (response) {

                var welcomeGiftData = {
                    id: 30707623919748,
                    quantity: 1
                };
                // Adding Free Gift
                $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: welcomeGiftData,
                    dataType: 'json',
                    success: function (response) {

                        // Fix Premium Membership Data
                        jQuery.post('/cart/update.js', {
                            updates: {
                                30707623919748: 1,
                                30706032345220: 1
                            }
                        });
                        setCookie('discount_code', 'SL-PREMIUM15', 1);
                        $('.btn-upsell-add-premium-membership').html('ADDED').addClass('btn-added');
                        window.localStorage.setItem('premium-membership','yes');
                        $('.upsell-upgrade-offer').hide();
                        // recomputeCart();
                        checkDiscountCodeBeforeRecompute();

                    }
                });
            }
        });
    }


    


    // Count Variants
    var productSetVariantIDs = [20201663955003, 31736963137668, 21126666321979, 7336427946043, 7327558893627];
    var productSetVariantCount = 0;

    function recomputeCart(){

        console.warn('recomputeCart(){');

        withSubscriptionProducts = false;

        $.getJSON('/cart.js', function (response) {
            console.log(response);
         
            cartOriginalGrandTotal = response.original_total_price / 100;
            cartOriginalGrandTotal = cartOriginalGrandTotal.toFixed(2);

            var itemCount = response.item_count;


            // Remove Shipping Protection - 2020-09-04
            if (shippingProtectStatus){
                itemCount = parseInt(itemCount);
                itemCount = itemCount - 1;
            }


            totalLineItemQuantity = itemCount;

            var discountType = '';
            var discountValue = '';

            var cartLineItems = response.items;
            cartItems = cartLineItems;

            var newTotalPrice = 0;

            var discounted = false;

            if (cartLineItems.length){
                // $.each(cartLineItems, function (index, lineItem) {


                //     console.warn('lineItem');
                //     console.warn(lineItem);


                //     var linePrice = lineItem.line_price / 100;

                //     if (lineItem.properties !== null ){

                //         if (typeof lineItem.selling_plan !== 'undefined'){

                //             discountType = 'percentage';
                //             discountValue = 0.15;

                //             linePrice = linePrice - (linePrice * discountValue);
                //             discounted = true;

                //             // Remove Discount Details
                //             withSubscriptionProducts = true;
                //             $('.cart-generic-notes').hide();
                            
                //         }
                //     }

                //     newTotalPrice+= linePrice;

                // });


                var currentDiscountCode = getCookie('discount_code');
                if (currentDiscountCode !== null && currentDiscountCode === 'SL-PREMIUM15') {

                    var premiumMembershipVariantID = 30706032345220;
                    var premiumMembershipGiftVariantID = 30707623919748;

                    $.each(cartLineItems, function (index, lineItem) {

                        console.warn('lineItem');
                        console.warn(lineItem);
                        var linePrice = lineItem.line_price / 100;

                        if (lineItem.id !== premiumMembershipVariantID && lineItem.id !== premiumMembershipGiftVariantID) {
                            discountType = 'percentage';
                            discountValue = 0.15; // SL-PREMIUM
                            linePrice = linePrice - (linePrice * discountValue);
                        }

                        // if (lineItem.properties !== null) {
                            if (typeof lineItem.selling_plan_allocation !== 'undefined') {
                                withSubscriptionProducts = true;
                            }
                        // }
                        $('.cart-generic-notes').hide();
                        newTotalPrice += linePrice;
                    });
                    discounted = true;

                } else {


                    productSetVariantCount = 0;

                    $.each(cartLineItems, function (index, lineItem) {


                        console.warn('lineItem');
                        console.warn(lineItem);


                        // Count Variants
                        if (productSetVariantIDs.indexOf(lineItem.id) >= 0){
                            productSetVariantCount+=lineItem.quantity;
                        }
                        
                        
                        var linePrice = lineItem.line_price / 100;
                        
                        if (typeof lineItem.selling_plan_allocation !== 'undefined') {

                            linePrice = lineItem.selling_plan_allocation.compare_at_price / 100;
                            if (linePrice != 0.98){
                                

                                console.log('linePrice',linePrice);

                                discountType = 'percentage';
                                discountValue = discountValueSubscription;

                                linePrice = linePrice - (linePrice * discountValue);
                                discounted = true;

                                // Remove Discount Details
                                withSubscriptionProducts = true;
                                $('.cart-generic-notes').hide();
                            }
                            

                        }
                        newTotalPrice += linePrice * lineItem.quantity;
                         console.log('Line Item Total Price ' + (linePrice * lineItem.quantity));
                    });

                    console.log('Final ' + newTotalPrice);
                    console.warn('productSetVariantCount: ' + productSetVariantCount);


                }

                newTotalPrice = newTotalPrice.toFixed(2);
                handleCartTotal(newTotalPrice);


             
                if ( !withSubscriptionProducts && typeof DISCOUNT_CODE_DETAILS !== 'undefined'){

                    // Remove Discount Details
                    $('.upsell-discount-code-details').hide();


                    console.warn('!!!Discount Details');
                    console.warn(DISCOUNT_CODE_DETAILS);

                    advanceCartDiscountConditions = DISCOUNT_CODE_DETAILS.fields;
                    switch (advanceCartDiscountConditions.discount_type) {

                        case 'percentage':
                            handleAdvanceCartPercentageDiscounts();
                            initDiscountCodeUpgradeRules(itemCount);
                        break;

                        case 'fixed_amount':
                            handleAdvanceCartFixedAmountDiscounts();
                            initDiscountCodeUpgradeRules(itemCount);
                        break;

                        case 'fixed_percentage':
                            handleAdvanceCartFixedPercentageDiscounts();
                            initDiscountCodeUpgradeRules(itemCount);
                        break;

                        case 'buy_x_get_y':
                            handleAdvanceCartBuyXGetYDiscounts();
                            initDiscountCodeUpgradeRules(itemCount);
                        break;

                        default:
                            console.warn('initDiscountCodeUpgradeRules(itemCount);');
                            initDiscountCodeUpgradeRules(itemCount);

                    }
                    

                
                }else{


                    if (withSubscriptionProducts){
                        $('.upsell-discount-code-details').hide();
                        var successNotes = 'You will get 15% OFF for all the subscription products.';
                        addGenericSuccessNotes(successNotes);
                        setCookie('discount_code','',999);
                    }else{
                        $('.upsell-discount-code-details').show();
                    }


                    // MD_initCustomQuantityDiscount();
                    // console.warn('MD_initCustomQuantityDiscount();');
                    // if (currentDiscountCode !== null && currentDiscountCode === 'MARDI50') {
                    //     $('.upsell-discount-code-details').hide();
                    //     MD_initCustomQuantityDiscount();
                    // }

                    console.warn('buyXGetYModule.init(currentDiscountCode);');
                    buyXGetYModule.init(currentDiscountCode, cartLineItems);

                    
                }
            }

           
            $('.upsell-total-quantity-label').html('(' + itemCount + ' items)').attr('data-item-count', itemCount);
            $('.upsell-cart-link').html('PROCEED TO CHECKOUT').removeClass('upsell-updating-cart');;
            
            upsellFloatTrigger();

        });
    }

    function upsellFloatTrigger() {
        $('.upsell-mobile-only .cart-generic-notes').addClass('cart-generic-notes-float').fadeTo('slow',1);
        
    }
    
    function handleCartTotal(newTotalPrice){

        console.warn('newTotalPrice: ' + newTotalPrice);
        console.warn('cartOriginalGrandTotal: ' + cartOriginalGrandTotal);

        if (newTotalPrice == cartOriginalGrandTotal) {
            $('.upsell-subtotal').html(slCurrencySymbol + cartOriginalGrandTotal);
        } else {

            cartOriginalGrandTotal = parseFloat(cartOriginalGrandTotal);
            cartOriginalGrandTotal = cartOriginalGrandTotal.toFixed(2);
            $('.upsell-subtotal').html('<span class="original-sub-total">' + slCurrencySymbol + cartOriginalGrandTotal + '</span><span class="discounted-sub-total">' + slCurrencySymbol + newTotalPrice + '</span>');

            var amountSaved = cartOriginalGrandTotal - newTotalPrice;
            amountSaved = amountSaved.toFixed(2);
            $('.save-amount').html(amountSaved); 
        }
    }

    function handleAdvanceCartPercentageDiscounts(){

        console.warn('handleAdvanceCartPercentageDiscounts()');
        console.warn(advanceCartDiscountConditions);

        var discountPercentage = advanceCartDiscountConditions.discount_value_percentage / 100;

        console.log('discountPercentage: ' + discountPercentage);
        
        switch (advanceCartDiscountConditions.minimum_requirements) {

            case 'minimum_purchase_amount':

                var min = advanceCartDiscountConditions.minimum_purchase_amount;
                min = parseFloat(min);

                var max = advanceCartDiscountConditions.maximum_purchase_amount;
                max = parseFloat(max);

                console.warn('minimum_purchase_amount: ' + min);
                console.warn('maximum_purchase_amount: ' + max);
                console.warn('cartOriginalGrandTotal: ' + cartOriginalGrandTotal);

                if (cartOriginalGrandTotal >= min && cartOriginalGrandTotal <= max) {

                    var successNotes = advanceCartDiscountConditions.minimum_requirements_success_notes_for_upsell_cart;

                    if (typeof successNotes !== 'undefined'){
                        successNotes = handleAdvanceCartShortCodes(successNotes);
                        addGenericSuccessNotes(successNotes);
                    }

                    
                    cartDiscountConditionValid = true;

                    $('.upsell-continue-link').attr('data-redirect', 'https://www.shinyleaf.com/collections/all' );

                } else {

                    var failedNotes = advanceCartDiscountConditions.minimum_requirements_failed_notes_for_upsell_cart;

                    if (typeof failedNotes !== 'undefined') {
                        failedNotes = handleAdvanceCartShortCodes(failedNotes);
                        addGenericFailedNotes(failedNotes);
                    }

                    cartDiscountConditionValid = false;


                    // Change Continue Shopping Link
                    $('.upsell-continue-link').attr('data-redirect','https://www.shinyleaf.com/collections/all');
                }

                break;

        }

        // Apply Discount
        if (cartDiscountConditionValid) {

            
            // Apply Discount to Line Items
            switch (advanceCartDiscountConditions.applies_to) {

                case 'entire_order':

                    if (advanceCartDiscountConditions.discount_applicable_product_types.indexOf('onetime') >= 0) {
                        discountValueOneTime = discountPercentage;

                    } else {
                        discountValueOneTime = 0;
                    }

                    if (advanceCartDiscountConditions.discount_applicable_product_types.indexOf('subscription') >= 0) {
                        discountValueSubscription = discountPercentage;
                    } else {
                        discountValueSubscription = 0;
                    }


                    // We need to less then discounted premium
                    if (window.localStorage.getItem('premium-membership')) {
                        
                        console.warn('*** We need to less then discounted premium ***');
                        cartOriginalGrandTotal-=15;
                        var newTotalPrice = (cartOriginalGrandTotal) - (cartOriginalGrandTotal * discountPercentage);
                        newTotalPrice+=15;

                    }else{
                        var newTotalPrice = cartOriginalGrandTotal - (cartOriginalGrandTotal * discountPercentage);
                    }



                    newTotalPrice = newTotalPrice.toFixed(2);
                    handleCartTotal(newTotalPrice);


                    applyUpsellProductsPriceDiscount();
                    

                    break;

                case 'specific_products':

                    if (advanceCartDiscountConditions.discount_applicable_product_types.indexOf('onetime') >= 0) {
                        discountValueOneTime = discountPercentage;

                    } else {
                        discountValueOneTime = 0;
                    }

                    if (advanceCartDiscountConditions.discount_applicable_product_types.indexOf('subscription') >= 0) {
                        discountValueSubscription = discountPercentage;
                    } else {
                        discountValueSubscription = 0;
                    }

                    console.log('---');
                    console.log('discountValueOneTime: ' + discountValueOneTime);
                    console.log('discountValueSubscription: ' + discountValueSubscription);
                    console.log('---');

                    var appliesToSpecificProduct = advanceCartDiscountConditions.applies_to_specific_products;
                    var appliesToSpecificProductIDs = [];
                    

                    $.each(appliesToSpecificProduct, function (key, value) {

                        var variantBought = value.split('~');
                        appliesToSpecificProductIDs.push(variantBought[1]);

                    });

                    console.warn('appliesToSpecificProductIDs:');
                    

                    console.warn('reUpdatePriceAgain: function () {');
                    console.warn(cartItems);
                    var newTotalPrice = 0;

                    $.each(cartItems, function (index, lineItem){

                        var linePrice = lineItem.line_price / 100;
                        linePrice = parseFloat(linePrice);
                        var discountedPrice = linePrice;

                        console.log('lineItem.variant_id: ' + lineItem.variant_id );
                        console.log(appliesToSpecificProductIDs);
                        console.log('INDEX: ' + appliesToSpecificProductIDs.indexOf( lineItem.variant_id.toString() ));

                        if (appliesToSpecificProductIDs.indexOf(lineItem.variant_id.toString()) >= 0 ){
                            
                            if (discountValueSubscription > 0 || discountValueOneTime > 0) {


                                if (lineItem.properties !== null ){

                                    if (typeof lineItem.selling_plan !== 'undefined'){
                                        console.log('lineItem.selling_plan : ' + lineItem.selling_plan);
                                        discountedPrice = discountedPrice - (discountedPrice * discountValueSubscription);
                                    }


                                } else {

                                    console.log('not lineItem.selling_plan');
                                    discountedPrice = discountedPrice - (discountedPrice * discountValueOneTime);
                                }

                                newTotalPrice += parseFloat(discountedPrice);

                            }else{
                                newTotalPrice += parseFloat(discountedPrice);
                            }
                        }else{
                            newTotalPrice += parseFloat(discountedPrice);
                        }
                        
                    });

                    newTotalPrice = newTotalPrice.toFixed(2);
                    handleCartTotal(newTotalPrice);
                    console.log('handleCartTotal(newTotalPrice); ---> ' + newTotalPrice);

                break;

            };


        }

    }


    function applyUpsellProductsPriceDiscount(){
        console.warn('applyUpsellProductsPriceDiscount();');
        console.warn('---> discountValueOneTime:' + discountValueOneTime);

        $('.upsell-product-container').each(function(){

            $(this).find('.price-discount').remove();

            var priceContainer =  $(this).find('.price');
            priceContainer.removeClass('upsell-product-with-discount');

            if (discountValueOneTime > 0){

                var quantitySelector = $(this).find('.quantity select');
                var variantSelector = $(this).find('.variation-selector select');
                var variantID = variantSelector.find('option:selected').val();
                var price = variantSelector.find('option:selected').attr('data-price');
                price = parseFloat(price);

                var quantity = quantitySelector.val();
                var newPrice = price * quantity;
                newPrice = newPrice.toFixed(2);

                priceContainer.addClass('upsell-product-with-discount');
                var discountedPrice = newPrice - (newPrice * discountValueOneTime);
                discountedPrice = discountedPrice.toFixed(2);


                // March 18, 2024 - Discounted
                if (slShopify.currency.active !== 'USD'){
                    var slCurrencyRate = slShopify.currency.rate;
                    discountedPrice = discountedPrice * slCurrencyRate;
                    discountedPrice = discountedPrice.toFixed(2);
                }

                priceContainer.after('<span class="price-discount">' + slCurrencySymbol + discountedPrice + '</span>'); 
                
            }

        });
    }


    function handleAdvanceCartFixedAmountDiscounts(){

        console.warn('handleAdvanceCartFixedAmountDiscounts()');
        console.warn(advanceCartDiscountConditions);

        var discountFixedAmount = advanceCartDiscountConditions.discount_value_fixed_amount;

        console.log('discountFixedAmount: ' + discountFixedAmount);
        
        switch (advanceCartDiscountConditions.minimum_requirements) {

            case 'minimum_purchase_amount':

                var min = advanceCartDiscountConditions.minimum_purchase_amount;
                min = parseFloat(min);

                var max = advanceCartDiscountConditions.maximum_purchase_amount;
                max = parseFloat(max);

                console.warn('minimum_purchase_amount: ' + min);
                console.warn('maximum_purchase_amount: ' + max);
                console.warn('cartOriginalGrandTotal: ' + cartOriginalGrandTotal);

                if (cartOriginalGrandTotal >= min && cartOriginalGrandTotal <= max) {

                    var successNotes = advanceCartDiscountConditions.minimum_requirements_success_notes_for_upsell_cart;

                    successNotes = handleAdvanceCartShortCodes(successNotes);
                    addGenericSuccessNotes(successNotes);
                    cartDiscountConditionValid = true;

                    $('.upsell-continue-link').attr('data-redirect', null );

                } else {


                    var failedNotes = advanceCartDiscountConditions.minimum_requirements_failed_notes_for_upsell_cart;
                    failedNotes = handleAdvanceCartShortCodes(failedNotes);
                    addGenericFailedNotes(failedNotes);
                    cartDiscountConditionValid = false;


                    // Change Continue Shopping Link
                    $('.upsell-continue-link').attr('data-redirect','https://www.shinyleaf.com/collections/all');
                }

            break;



            case 'minimum_quantity_items': // 2020-08-11


                var min = advanceCartDiscountConditions.minimum_quantity_of_items;
                var max = advanceCartDiscountConditions.maximum_quantity_of_items;
                var productRequirementCount = 0;
                var appliesToSpecificProduct = advanceCartDiscountConditions.applies_to_specific_products;
                var appliesTo = advanceCartDiscountConditions.applies_to;
                var appliesToSpecificProductIDs = [];

                if (appliesTo == 'specific_products'){

                    $.each(appliesToSpecificProduct, function (key, value) {

                        var variantBought = value.split('~');
                        appliesToSpecificProductIDs.push(variantBought[1]);

                    });

                    $.each(cartItems, function (index, lineItem) {

                        if (appliesToSpecificProductIDs.indexOf(lineItem.variant_id.toString()) >= 0) {
                            productRequirementCount+= lineItem.quantity;
                        }
                    });

                    if (productRequirementCount >= min && productRequirementCount <= max) {

                        var successNotes = advanceCartDiscountConditions.minimum_requirements_success_notes_for_upsell_cart;

                        successNotes = handleAdvanceCartShortCodes(successNotes);
                        addGenericSuccessNotes(successNotes);
                        cartDiscountConditionValid = true;

                    } else {

                        var failedNotes = advanceCartDiscountConditions.minimum_requirements_failed_notes_for_upsell_cart;
                        failedNotes = handleAdvanceCartShortCodes(failedNotes);
                        addGenericFailedNotes(failedNotes);
                        cartDiscountConditionValid = false;

                    }
                
                }


            break;

        }


        // Apply Discount
        if (cartDiscountConditionValid) {


            // Apply Discount to Line Items
            switch (advanceCartDiscountConditions.applies_to) {

                case 'entire_order':

                    var newTotalPrice = cartOriginalGrandTotal - discountFixedAmount;
                    newTotalPrice = newTotalPrice.toFixed(2);
                    handleCartTotal(newTotalPrice);

                    break;

                case 'specific_products':


                    var appliesToSpecificProduct = advanceCartDiscountConditions.applies_to_specific_products;
                    var appliesToSpecificProductIDs = [];


                    $.each(appliesToSpecificProduct, function (key, value) {

                        var variantBought = value.split('~');
                        appliesToSpecificProductIDs.push(variantBought[1]);

                    });

                    console.warn('appliesToSpecificProductIDs:');


                    console.warn('reUpdatePriceAgain: function () {');
                    console.warn(cartItems);
                    var newTotalPrice = 0;

                    $.each(cartItems, function (index, lineItem) {

                        var linePrice = lineItem.line_price / 100;
                        linePrice = parseFloat(linePrice);
                        var discountedPrice = linePrice;


                        console.log('----------------');
                        console.log('discountedPrice: ' + discountedPrice);
                        console.log('lineItem.variant_id: ' + lineItem.variant_id);
                        console.log(appliesToSpecificProductIDs);
                        console.log('INDEX: ' + appliesToSpecificProductIDs.indexOf(lineItem.variant_id.toString()));

                        if (appliesToSpecificProductIDs.indexOf(lineItem.variant_id.toString()) >= 0) {
                            console.log('discountedPrice = discountedPrice - discountFixedAmount: --> ' + discountedPrice - discountFixedAmount);
                            newTotalPrice += parseFloat(discountedPrice - (discountFixedAmount * lineItem.quantity) );
                        } else {
                            newTotalPrice += parseFloat(discountedPrice);
                        }

                    });

                    newTotalPrice = newTotalPrice.toFixed(2);
                    handleCartTotal(newTotalPrice);
                    console.log('handleCartTotal(newTotalPrice); ---> ' + newTotalPrice);

                    break;

            };


        }

    }


    function handleAdvanceCartFixedPercentageDiscounts(){

        // Check If there is an on the cart
        // Checking if first click trigger

        var minTotal = advanceCartDiscountConditions.discount_value_fixed_percentage_min_total;
        cartOriginalGrandTotal = parseFloat(cartOriginalGrandTotal);

        
        if (cartOriginalGrandTotal >= minTotal){
            

            // Getting current rule       
            var fixedPercentageUpgrades = advanceCartDiscountConditions.discount_value_fixed_percentage_upgrade;
            $.each(fixedPercentageUpgrades,function(index,fixedPercentageUpgrade){
                currentFixedPercentageRules[fixedPercentageUpgrade.value] = {
                    discountValue : fixedPercentageUpgrade.value,
                    discountNote : fixedPercentageUpgrade.note,
                    discountSuccess : fixedPercentageUpgrade.success,
                };
            });

            
            var fixedPercentageRules = window.localStorage.getItem('fixedPercentageRules' + getCookie('discount_code'));

            if (!fixedPercentageRules){
                getTargetPricesInit();
            }else{
                getTargetPricesReTest(fixedPercentageRules);
            }

        }else{
            var failedNotes = advanceCartDiscountConditions.minimum_requirements_failed_notes_for_upsell_cart;
            if (typeof failedNotes !== 'undefined') {
                // failedNotes = handleAdvanceCartShortCodes(failedNotes);
                var amountRemaining = minTotal - cartOriginalGrandTotal;
                amountRemaining = amountRemaining.toFixed(2);

                failedNotes = failedNotes.replace('[amount_remaining]',amountRemaining);
                addGenericFailedNotes(failedNotes);
            }
        }


    }

    function getTargetPricesInit(){
        

        var minTotal = advanceCartDiscountConditions.discount_value_fixed_percentage_min_total;
        var fixedPercentageDiscount = advanceCartDiscountConditions.discount_value_fixed_percentage;
        discountValueOneTime = (fixedPercentageDiscount / 100);
        // We need to less then discounted premium
        if (window.localStorage.getItem('premium-membership')) {
            
            console.warn('*** We need to less then discounted premium ***');
            cartOriginalGrandTotal-=15;
            var newTotalPrice = (cartOriginalGrandTotal) - (cartOriginalGrandTotal * discountValueOneTime);
            newTotalPrice+=15;

        }else{
            var newTotalPrice = cartOriginalGrandTotal - (cartOriginalGrandTotal * discountValueOneTime);
        }



        newTotalPrice = newTotalPrice.toFixed(2);
        handleCartTotal(newTotalPrice);

        applyUpsellProductsPriceDiscount();
        checkFixedPercentageNotes();

        var fixedPercentageRules = window.localStorage.getItem('fixedPercentageRules' + getCookie('discount_code'));
        if (fixedPercentageRules){
            getTargetPricesReTest(fixedPercentageRules);
        }

    }


    function getTargetPricesReTest(fixedPercentageRules){


        var minTotal = advanceCartDiscountConditions.discount_value_fixed_percentage_min_total;
        var fixedPercentageDiscount = advanceCartDiscountConditions.discount_value_fixed_percentage;
        
        fixedPercentageRules = JSON.parse(fixedPercentageRules);
        var activeRule = {};


        $.each(fixedPercentageRules, function(index,fixedPercentageRule){
            var discountAmountRequiredSuggestion = fixedPercentageRule.discountAmountRequiredSuggestion;
            
            if (cartOriginalGrandTotal >= discountAmountRequiredSuggestion){
                activeRule = fixedPercentageRule; 
            }

        });

        console.warn('activeRule for Fixed%');
        console.warn(activeRule);
        
        var successNotes = advanceCartDiscountConditions.minimum_requirements_success_notes_for_upsell_cart;
        if (!$.isEmptyObject(activeRule)){
            
            successNotes = currentFixedPercentageRules[activeRule.discountValue].discountSuccess;
            if (typeof successNotes !== 'undefined'){

                successNotes = successNotes.replace('[fx_value]',activeRule.discountValue);
                successNotes = successNotes.replace('[fx_saved]','<span class="save-amount"></span>');
                displayFixedPercentageSuccess(successNotes);
            }
            

            var discountPercentage = (activeRule.discountValue / 100);
            discountValueOneTime = discountPercentage;

            // We need to less then discounted premium
            if (window.localStorage.getItem('premium-membership')) {
                
                console.warn('*** We need to less then discounted premium ***');
                cartOriginalGrandTotal-=15;
                var newTotalPrice = (cartOriginalGrandTotal) - (cartOriginalGrandTotal * discountPercentage);
                newTotalPrice+=15;

            }else{
                var newTotalPrice = cartOriginalGrandTotal - (cartOriginalGrandTotal * discountPercentage);
            }



            newTotalPrice = newTotalPrice.toFixed(2);
            handleCartTotal(newTotalPrice);
            applyUpsellProductsPriceDiscount();

        }else{

            // Sesssion exist but the cart total is not enough
            var successNotes = advanceCartDiscountConditions.minimum_requirements_success_notes_for_upsell_cart
            displayFixedPercentageSuccess(successNotes);

            var discountPercentage = (fixedPercentageDiscount / 100);
            discountValueOneTime = discountPercentage;

            // We need to less then discounted premium
            if (window.localStorage.getItem('premium-membership')) {
                
                console.warn('*** We need to less then discounted premium ***');
                cartOriginalGrandTotal-=15;
                var newTotalPrice = (cartOriginalGrandTotal) - (cartOriginalGrandTotal * discountPercentage);
                newTotalPrice+=15;

            }else{
                var newTotalPrice = cartOriginalGrandTotal - (cartOriginalGrandTotal * discountPercentage);
            }



            newTotalPrice = newTotalPrice.toFixed(2);
            handleCartTotal(newTotalPrice);
            applyUpsellProductsPriceDiscount();


        }

        displayFixedPercentageUpgradeNoteBySession(fixedPercentageRules);

    }

    function displayFixedPercentageUpgradeNoteBySession(fixedPercentageRules){
        $('.upsell-fx-upgrade-offer,.upsell-upgrade-offer').remove();

        var upsellProductHTML = '';
        upsellProductHTML += '<div class="upsell-fx-upgrade-offer">';
        var validStatus = false;

        var first = true;
        var firstOffer = {};

        $.each(fixedPercentageRules, function(index,activeRule){
            var discountAmountRequiredSuggestion = activeRule.discountAmountRequiredSuggestion;
            if (cartOriginalGrandTotal < discountAmountRequiredSuggestion){
                var remaining = discountAmountRequiredSuggestion-cartOriginalGrandTotal;
                remaining = remaining.toFixed(2);
                upsellProductHTML += checkFixedPercentageShortcode(currentFixedPercentageRules[activeRule.discountValue].discountNote,activeRule);
                validStatus = true;

                if (first){
                    firstOffer = activeRule;
                    first = false;
                }
            }
        });
        

        if (!first){
            var discountAmountRequiredSuggestion = firstOffer.discountAmountRequiredSuggestion;

            // discountAmountRequiredSuggestion = checkFixedPercentageShortcode(discountAmountRequiredSuggestion);
            // text = text.toString().replace('$',slCurrencySymbol);
    


            
            var percentage = (cartOriginalGrandTotal / discountAmountRequiredSuggestion) * 100;
            upsellProductHTML += '<div class="fx-progress-bar">';
            upsellProductHTML += '<div class="current-price" style="width:' + percentage + '%">' + slCurrencySymbol + cartOriginalGrandTotal + '</div>';
            upsellProductHTML += '<div class="target-price" style="width:' + (100-percentage) + '%">' + slCurrencySymbol + discountAmountRequiredSuggestion + '</div>';
            upsellProductHTML += '</div>';
            upsellProductHTML += '<div class="clearfix"></div>';
        }

        
        upsellProductHTML += '</div>';

        if (validStatus){
            $('.upsell-added-product').after(upsellProductHTML);
        }
        
    }

    function displayFixedPercentageSuccess(successNotes){
   
        if (typeof successNotes !== 'undefined'){
            addGenericSuccessNotes(successNotes);
        }
    }

    function checkFixedPercentageNotes(){

        var successNotes = advanceCartDiscountConditions.minimum_requirements_success_notes_for_upsell_cart
        displayFixedPercentageSuccess(successNotes);

        // Upgrade Notes
        $('.upsell-fx-upgrade-offer,.upsell-upgrade-offer').remove();

        var fixedPercentageUpgrades = advanceCartDiscountConditions.discount_value_fixed_percentage_upgrade;
        var availableFixedPercentageUpgrades = fixedPercentageUpgrades;

        // Showing Offer?
        var upsellProductHTML = '';
        upsellProductHTML += '<div class="upsell-fx-upgrade-offer">';

        console.warn('getTargetPrices');
        console.warn('getTargetPrices cartOriginalGrandTotal = ' + cartOriginalGrandTotal);
        console.warn(availableFixedPercentageUpgrades);
        
        var targetPrices = getTargetPrices(cartOriginalGrandTotal,availableFixedPercentageUpgrades);

        window.localStorage.setItem('fixedPercentageRules' + getCookie('discount_code'), JSON.stringify(targetPrices));

        $.each(targetPrices, function(index,activeRule){

            var discountAmountRequiredSuggestion = parseFloat(activeRule.discountAmountRequiredSuggestion);
            discountAmountRequiredSuggestion = discountAmountRequiredSuggestion.toFixed(2);

            var remainingAmount = parseFloat(activeRule.remainingAmount);
            remainingAmount = remainingAmount.toFixed(2);

            if (cartOriginalGrandTotal < discountAmountRequiredSuggestion){
                upsellProductHTML += checkFixedPercentageShortcode(currentFixedPercentageRules[activeRule.discountValue].discountNote,activeRule);
            }
            
        
        });

        
        upsellProductHTML += '</div>';
        $('.upsell-added-product').after(upsellProductHTML);
    }
    
    function checkFixedPercentageShortcode(text,activeRule){

        text = text.toString();
        text = unescapeHTML(text);

        // fx shortcode
        text = text.toString().replace('$',slCurrencySymbol);

        var discountAmountRequiredSuggestion = parseFloat(activeRule.discountAmountRequiredSuggestion);
        discountAmountRequiredSuggestion = discountAmountRequiredSuggestion.toFixed(2);
        var remainingAmount = discountAmountRequiredSuggestion - cartOriginalGrandTotal;
        remainingAmount = remainingAmount.toFixed(2);


        text = text.replace('[fx_required]',discountAmountRequiredSuggestion);
        text = text.replace('[fx_remaining]',remainingAmount);
        text = text.replace('[fx_value]',activeRule.discountValue);

        
        
        return text;
    }

    function getTargetPrices(startingValue,rules){
        
        startingValue = parseFloat(startingValue);

        console.warn('startingValue = ' + startingValue);

        var targetPrices = [];
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear().toString().substr(2,2);

        var previousValue = 0;
        $.each(rules, function(index,rule){

            console.log('rule ' + rule);

            let discountValue = parseFloat(rule.value);
            let discountType = rule.type;
            let discountFactor = rule.factor;
            let discountNote = rule.note;
            let discountSuccess = rule.success;
            let discountFactorPercentage = discountFactor/100;

            let discountAmountRequired = 0;
            let discountAmountRequiredSuggestion = 0;
            
            if (previousValue == 0){ // default

                discountAmountRequired = (startingValue * discountFactorPercentage) + startingValue;

            }else{

                discountAmountRequired = (previousValue * discountFactorPercentage) + previousValue;

            }   
            
            discountAmountRequiredSuggestion = (Math.ceil( (discountAmountRequired+1) /10 ) * 10) - 1; // 9th
            previousValue = discountAmountRequiredSuggestion;

            let randomNumbers = Math.floor(100000 + Math.random() * 900000);
            let discountCodeGenerated = 'FX-' + discountValue + '-' + yyyy + mm + dd + '-' + randomNumbers; //FX-15-210412-389269  
            

            let remainingAmount = discountAmountRequiredSuggestion - startingValue;
            remainingAmount = remainingAmount.toFixed(2);

            var targetPrice = {
                discountValue : discountValue,
                discountType : discountType,
                discountCodeGenerated : discountCodeGenerated,
                discountAmountRequired : discountAmountRequired,
                remainingAmount : remainingAmount,
                discountAmountRequiredSuggestion : discountAmountRequiredSuggestion,
                discountNote : discountNote,
                discountSuccess : discountSuccess,
            }
            targetPrices.push(targetPrice);
        });

        return targetPrices;
    }


    function addGenericSuccessNotes(notes){
        $('.cart-generic-notes').remove();
        $('.upsell-mobile-only').html('<div class="cart-generic-notes cart-generic-success-notes">' + unescapeHTML(notes) + '</div>');
        $('.upsell-added-product .summary').prepend('<div class="cart-generic-notes cart-generic-success-notes">' + unescapeHTML(notes) + '</div>');

    }

    function addGenericFailedNotes(notes) {
        $('.cart-generic-notes').remove();
        $('.upsell-mobile-only').html('<div class="cart-generic-notes cart-generic-failed-notes">' + unescapeHTML(notes) + '</div>');
        $('.upsell-added-product .summary').prepend('<div class="cart-generic-notes cart-generic-failed-notes">' + unescapeHTML(notes) + '</div>');
        
    }

    


    function handleAdvanceCartShortCodes(notes){


        // March 18, 2024
        if (slShopify.currency.active !== 'USD'){
            notes = notes.toString().replace('$',slCurrencySymbol);
    
        }


        if (notes.indexOf('[continue_shopping]') >= 0) {
            notes = notes.replace('[continue_shopping]', '<a class="link-continue-shopping" href="https://www.shinyleaf.com/collections/all">Continue shopping...</a>');
        }

        if (notes.indexOf('[first_free_product_remaining]') >= 0) {

            // Get First Free Product
            var firstFreeProductMin = advanceCartDiscountConditions.free_products[0].min;
            var firstFreeProductMax = advanceCartDiscountConditions.free_products[0].max;
            var firstFreeProductSuccessNotes = advanceCartDiscountConditions.free_products[0].notes;

            var firstFreeProductRemaining = firstFreeProductMin - cartOriginalGrandTotal;
            firstFreeProductRemaining = firstFreeProductRemaining.toFixed(2);
            notes = notes.replace('[first_free_product_remaining]', firstFreeProductRemaining);

        }

        if (notes.indexOf('[second_free_product_remaining]') >= 0) {

            // Get First Free Product
            var firstFreeProductMin = advanceCartDiscountConditions.free_products[1].min;
            var firstFreeProductMax = advanceCartDiscountConditions.free_products[1].max;
            var firstFreeProductSuccessNotes = advanceCartDiscountConditions.free_products[1].notes;

            var firstFreeProductRemaining = firstFreeProductMin - cartOriginalGrandTotal;
            firstFreeProductRemaining = firstFreeProductRemaining.toFixed(2);
            notes = notes.replace('[second_free_product_remaining]', firstFreeProductRemaining);

        }

        if (notes.indexOf('[amount_remaining]') >= 0) {

            var cartTotalMin = advanceCartDiscountConditions.minimum_purchase_amount;
            var cartTotalMax = advanceCartDiscountConditions.maximum_purchase_amount;
            var amountRemaining = cartTotalMin - cartOriginalGrandTotal;
            amountRemaining = amountRemaining.toFixed(2);
            notes = notes.replace('[amount_remaining]', amountRemaining);

        }

        
        return notes;

    }


    function unescapeHTML(str) {
        return str.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
    }


    $(document).on('click','.upsell-cart-link',function(){

        ga('send', 'event', 'Shiny Leaf Upsell', 'Click', 'Cart Link');
        window.location.href = 'https://www.shinyleaf.com/cart';
    });

    $(document).on('click', '.upsell-continue-link', function () {

        $('.upsell-continue-link').attr('data-redirect', 'https://www.shinyleaf.com/collections/all');
        if (typeof $(this).attr('data-redirect') !== 'undefined'){
            window.location.href = $(this).attr('data-redirect');
        }else{
            $.magnificPopup.close();
            $('body').removeClass('open-popup'); 
        }
        
    });


    // Event Handlers
    $(document).on('change click','.upsell-custom-purchase-type', function(){
        triggerChange($(this));

        ga('send', 'event', 'Shiny Leaf Upsell', 'Change', 'Upsell Product Type');


    });

    $(document).on('change blur','.upsell-product-container select', function(){

        ga('send', 'event', 'Shiny Leaf Upsell', 'Change', 'Upsell Product Quantity');

        triggerChange($(this));
    });


    function triggerChange(thisElement){

        var parentUpsellProduct = thisElement.parents('.upsell-product-container');
        var quantitySelector = parentUpsellProduct.find('.quantity select');
        var variantSelector = parentUpsellProduct.find('.variation-selector select');

        var purchaseType = parentUpsellProduct.find('.upsell-custom-purchase-type:checked');

        var priceHTML = parentUpsellProduct.find('.price strong');
        var priceContainer = parentUpsellProduct.find('.price');


        // Remove Any Price Discount
        parentUpsellProduct.find('.price-discount').remove();


        var variantID = variantSelector.find('option:selected').val();
        var variantImage = variantSelector.find('option:selected').attr('data-image');
        parentUpsellProduct.find('img').attr('src', variantImage);

        var price = variantSelector.find('option:selected').attr('data-price');
        price = parseFloat(price);

        var quantity = quantitySelector.val();
        var newPrice = price * quantity;
        newPrice = newPrice.toFixed(2);


        var discountPercent = 0;
        if (purchaseType.val() == 'onetime') {
            discountPercent = 0;
            priceContainer.removeClass('upsell-product-with-discount');
        } else {
            priceContainer.addClass('upsell-product-with-discount');
            discountPercent = discountValueSubscription;
            var discountedPrice = newPrice - (newPrice * discountPercent);
            discountedPrice = discountedPrice.toFixed(2);
            priceContainer.after('<span class="price-discount">' + slCurrencySymbol + discountedPrice + '</span>');  
        }

        console.log('triggerChange');



        priceHTML.html(slCurrencySymbol + newPrice);

        if (purchaseType.val() == 'onetime') {
            applyUpsellProductsPriceDiscount();
        }

        

        // Reset Button
        parentUpsellProduct.find('button').removeClass('btn-added').html('ADD TO ORDER');

        console.log('Variant ID: ' + variantID + ' | Quantity: ' + quantity + ' | Price: $' + price + ' | Sub Total: $' + newPrice);

    }


    


    $(document).on('click','.upsell-product-container button.btn-add-to-order', function(e){

        e.preventDefault();
        
        var thisButton = $(this);

        if ( !thisButton.hasClass('btn-added') ){

            thisButton.html('PLEASE WAIT...');
            
            $('.upsell-cart-link').html('UPDATING YOUR CART...').addClass('upsell-updating-cart');

            ga('send', 'event', 'Shiny Leaf Upsell', 'Click', 'Upsell Product Add');



            var parentUpsellProduct = $(this).parents('.upsell-product-container');
            var quantity = parentUpsellProduct.find('.quantity select').val();
            var variantID = parentUpsellProduct.find('.variation-selector select').find('option:selected').val();


            var purchaseType = parentUpsellProduct.find('.upsell-custom-purchase-type:checked');
            var autoDeliveryInterval = parentUpsellProduct.find('.upsell-custom-auto-deliver');


            console.log('Variant ID: ' + variantID + ' | Quantity: ' + quantity);

            if (purchaseType.val() == 'onetime') {
                var addedProductData = {
                    id: variantID,
                    quantity: quantity
                };
            } else {
                var addedProductData = {
                    id: variantID,
                    quantity: quantity,
                    properties: {
                        subscription_id: 213870,
                        shipping_interval_unit_type: 'Months',
                        shipping_interval_frequency: autoDeliveryInterval.val()
                    }
                };


                // Seal Subscription Override
                if (enableSealSubscription){
                    var selectedMonth = autoDeliveryInterval.val();
                    addedProductData.properties = {};
                    addedProductData.selling_plan = sellingPlans[selectedMonth];

                    withSubscriptionProducts = true;
                }


            }

            $.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: addedProductData,
                dataType: 'json',
                success: function (response) {

                    try {
                        window.stop();
                    } catch (exception) {
                        document.execCommand('Stop');
                    }
                    
                    

                    setTimeout(function(){
                        thisButton.html('ADDED').addClass('btn-added');
                        $(".mfp-wrap").scrollTop(0);
                        
                        setTimeout(function(){
                            thisButton.removeClass('btn-added').html('ADD TO ORDER');
                        },3000);

                    },3000);
                    
                    checkDiscountCodeBeforeRecompute();
                    
                }
            });

            

        }
        
    });

    function checkDiscountCodeBeforeRecompute(){


        console.log('>>.upsell-add-to-cart checkDiscountCodeBeforeRecompute()!');


        // if (!$('.member-status-premium').length){

        //     console.log('>>.upsell-add-to-cart checkDiscountCodeBeforeRecompute() - Not Loggein!');

        //     // var excludedDiscounts = ['END30'];
        //     // var excludedDiscounts = ['GOOGLE15', 'END30X', 'KASSIE20', 'SHINY143'];
        //     var excludedDiscounts = upgradeExcludedDiscounts;
        //     var currentDiscountCode = getCookie('discount_code');
        //     if (!$('.product-type-subscription').length && excludedDiscounts.indexOf(currentDiscountCode) == -1){

        //         $('.upsell-action button.upsell-cart-link').html('UPDATING YOUR CART...').addClass('upsell-updating-cart');
        //         $.getJSON('/cart.js', function (response) {
        //             console.log(response);
                 
        //             cartOriginalGrandTotal = response.original_total_price / 100;
        //             cartOriginalGrandTotal = cartOriginalGrandTotal.toFixed(2);
        
        //             var itemCount = response.item_count;
    
    
        //             $('.upsell-upgrade-offer').remove();
    
        //             var upsellProductHTML = '';
        //             var discountCode = '';
        //             upsellProductHTML+='<div class="upsell-upgrade-offer">';
        //             var itemCountValue = parseInt(itemCount);


        //             // Remove Shipping Protection - 2020-09-04
        //             if (shippingProtectStatus) {
        //                 itemCountValue = itemCountValue - 1;
        //             }

    
        //             var upSellUpgradeStatus = false;
    
        //             console.warn('itemCountValue: ' + itemCountValue);


    
        //             switch (itemCountValue){
        //                 case 1:
                        

        //                     console.warn('case 1:');
    
    
        //                     upsellProductHTML += upgradeDiscountDefaultNotes;
        //                     // upsellProductHTML+='<p>Add <strong>2</strong> more products and get <strong>13% OFF Discount</strong></p>';
    
    
        //                     var currentDiscountCode = getCookie('discount_code');
        //                     var oldDiscountCode = getCookie('old_discount_code');
    
        //                     if (oldDiscountCode !== null && oldDiscountCode !== ''){
                                
        //                         if (oldDiscountCode.indexOf('UPGRADE') == -1 ){
        //                             setCookie('discount_code', oldDiscountCode, 9999);
        //                         }else{
        //                             setCookie('old_discount_code', '', 9999);
        //                             setCookie('discount_code', '', 9999);
        //                         }

        //                     }else{
    
        //                         if (currentDiscountCode !== null && currentDiscountCode !== ''){
                                    
        //                             if (currentDiscountCode.indexOf('UPGRADE') == -1) {
        //                                 setCookie('old_discount_code', currentDiscountCode, 9999);
        //                             } else {
        //                                 setCookie('old_discount_code', '', 9999);
        //                                 setCookie('discount_code', '', 9999);
        //                             }
                                    
        //                         }
    
    
        //                     }
    
    
    
    
        //                     upSellUpgradeStatus = true;
        //                 break;
    
    
        //                 default:
    
        //                     if (itemCountValue >= 2){
                                

        //                         $.each(upgradeDiscountRuleSets, function (key, ruleSet) {

        //                             if (itemCountValue >= ruleSet.minimum_quantity && itemCountValue <= ruleSet.maximum_quantity) {

        //                                 console.warn('Matched >>');
        //                                 console.warn('Min: ' + ruleSet.minimum_quantity + ' Max: ' + ruleSet.maximum_quantity);
        //                                 console.warn('Code: ' + ruleSet.discount_code);
        //                                 console.warn('Notes: ' + ruleSet.notes);

        //                                 upsellProductHTML += ruleSet.notes;
        //                                 setCookie('discount_code', ruleSet.discount_code, 9999);

        //                                 if (ruleSet.last_option !== true) {
        //                                     upSellUpgradeStatus = true;
        //                                 }else{
        //                                     upSellUpgradeStatus = false;
        //                                 }

        //                                 console.warn('upSellUpgradeStatus: ' + upSellUpgradeStatus);


        //                             }

        //                         });

    
        //                     }
                            
        //             }
    
        //             upsellProductHTML+='</div>';
    
        //             console.warn('upSellUpgradeStatus: ' + upSellUpgradeStatus);
        //             if (upSellUpgradeStatus){
        //                 $('.upsell-added-product').after(upsellProductHTML);
        //             }
                    
        //             checkDiscountCodeBeforeRecomputeFinal();
    
        //         });

        //     }else{
        //         checkDiscountCodeBeforeRecomputeFinal();
        //         console.log('checkDiscountCodeBeforeRecomputeFinal(); FOR RC');
        //     }
            
        // }else{

        //     console.log('>>.upsell-add-to-cart checkDiscountCodeBeforeRecompute() - Logged In!');
        //     checkDiscountCodeBeforeRecomputeFinal();
        // }

        // Auto Apply Codes
        // July 4th Promotion

        var withCustomCode = false;
        var _customDiscountCode = getCookie('discount_code'); // current code
        
        
        
        // var tempCodes = ['SHINE5OFF','SHINE10OFF','SHINE15OFF']
        // if (tempCodes.indexOf(_customDiscountCode) !== -1) {

        //     $.getJSON('/cart.js', function (response) {
                
        //         cartOriginalGrandTotal = response.original_total_price / 100;
        //         cartOriginalGrandTotal = cartOriginalGrandTotal.toFixed(2);

        //         var _customDiscountCode = getCookie('discount_code'); // current code
        //         if (cartOriginalGrandTotal >= 69 ) {
        //             _customDiscountCode = 'SHINE15OFF';
        //         } else if (cartOriginalGrandTotal >= 49 ) {
        //             _customDiscountCode = 'SHINE10OFF';
        //         } else {
        //             _customDiscountCode = 'SHINE5OFF';
        //         }

        //         // if (cartOriginalGrandTotal >= 39 ) {
        //         //     _customDiscountCode = 'SALE22';
        //         // } else {
        //         //     _customDiscountCode = 'NY10';
        //         // }

        //         setCookie('discount_code_origin', getCookie('discount_code'), 9999);
        //         setCookie('discount_code', _customDiscountCode, 9999);
        //         checkDiscountCodeBeforeRecomputeFinal();
                
        //     });
        //     withCustomCode = true;

        // }



        var tempCodes = ['4HOFFJULY','7HOFFJULY']
        if (tempCodes.indexOf(_customDiscountCode) !== -1) {

            $.getJSON('/cart.js', function (response) {
                
                cartOriginalGrandTotal = response.original_total_price / 100;
                cartOriginalGrandTotal = cartOriginalGrandTotal.toFixed(2);

                var _customDiscountCode = getCookie('discount_code'); // current code
                if (cartOriginalGrandTotal >= 39 ) {
                    _customDiscountCode = '7HOFFJULY';
                } else {
                    _customDiscountCode = '4HOFFJULY';
                }

                setCookie('discount_code_origin', getCookie('discount_code'), 9999);
                setCookie('discount_code', _customDiscountCode, 9999);
                checkDiscountCodeBeforeRecomputeFinal();
                
            });
            withCustomCode = true;

        }


        var tempCodes = ['4ROFFJULY','7ROFFJULY']
        if (tempCodes.indexOf(_customDiscountCode) !== -1) {

            $.getJSON('/cart.js', function (response) {
                
                cartOriginalGrandTotal = response.original_total_price / 100;
                cartOriginalGrandTotal = cartOriginalGrandTotal.toFixed(2);

                var _customDiscountCode = getCookie('discount_code'); // current code
                if (cartOriginalGrandTotal >= 39 ) {
                    _customDiscountCode = '7ROFFJULY';
                } else {
                    _customDiscountCode = '4ROFFJULY';
                }

                setCookie('discount_code_origin', getCookie('discount_code'), 9999);
                setCookie('discount_code', _customDiscountCode, 9999);
                checkDiscountCodeBeforeRecomputeFinal();
                
            });
            withCustomCode = true;

        }


        var tempCodes = ['4COFFJULY','7COFFJULY']
        if (tempCodes.indexOf(_customDiscountCode) !== -1) {

            $.getJSON('/cart.js', function (response) {
                
                cartOriginalGrandTotal = response.original_total_price / 100;
                cartOriginalGrandTotal = cartOriginalGrandTotal.toFixed(2);

                var _customDiscountCode = getCookie('discount_code'); // current code
                if (cartOriginalGrandTotal >= 39 ) {
                    _customDiscountCode = '7COFFJULY';
                } else {
                    _customDiscountCode = '4COFFJULY';
                }

                setCookie('discount_code_origin', getCookie('discount_code'), 9999);
                setCookie('discount_code', _customDiscountCode, 9999);
                checkDiscountCodeBeforeRecomputeFinal();
                
            });
            withCustomCode = true;

        }

        // November 2022
        var tempCodes = ['BLCKF12','BLCKF15','BLCKF20','BLCKF25'];
        if (tempCodes.indexOf(_customDiscountCode) !== -1) {

            $.getJSON('/cart.js', function (response) {
                
                cartOriginalGrandTotal = response.original_total_price / 100;
                cartOriginalGrandTotal = cartOriginalGrandTotal.toFixed(2);

                var _customDiscountCode = getCookie('discount_code'); // current code
                if (cartOriginalGrandTotal >= 99 ) {
                    _customDiscountCode = 'BLCKF25';
                }else if (cartOriginalGrandTotal >= 69 ) {
                    _customDiscountCode = 'BLCKF20';
                }else if (cartOriginalGrandTotal >= 39 ) {
                    _customDiscountCode = 'BLCKF15';
                } else {
                    _customDiscountCode = 'BLCKF12';
                }

                setCookie('discount_code_origin', getCookie('discount_code'), 9999);
                setCookie('discount_code', _customDiscountCode, 9999);
                checkDiscountCodeBeforeRecomputeFinal();
                
            });
            withCustomCode = true;

        }

        // December 12, 2022
        var tempCodes = ['17OFFDEAL','1212DEALS'];
        if (tempCodes.indexOf(_customDiscountCode) !== -1) {

            $.getJSON('/cart.js', function (response) {
                
                cartOriginalGrandTotal = response.original_total_price / 100;
                cartOriginalGrandTotal = cartOriginalGrandTotal.toFixed(2);

                var _customDiscountCode = getCookie('discount_code'); // current code
                if (cartOriginalGrandTotal >= 49 ) {
                    _customDiscountCode = '17OFFDEAL';
                } else {
                    _customDiscountCode = '1212DEALS';
                }

                setCookie('discount_code_origin', getCookie('discount_code'), 9999);
                setCookie('discount_code', _customDiscountCode, 9999);
                checkDiscountCodeBeforeRecomputeFinal();
                
            });
            withCustomCode = true;

        }


        var tempCodes = ['BLCKTY12','BLCKTY15','BLCKTY20','BLCKTY25'];
        if (tempCodes.indexOf(_customDiscountCode) !== -1) {

            $.getJSON('/cart.js', function (response) {
                
                cartOriginalGrandTotal = response.original_total_price / 100;
                cartOriginalGrandTotal = cartOriginalGrandTotal.toFixed(2);

                var _customDiscountCode = getCookie('discount_code'); // current code
                if (cartOriginalGrandTotal >= 99 ) {
                    _customDiscountCode = 'BLCKTY25';
                }else if (cartOriginalGrandTotal >= 69 ) {
                    _customDiscountCode = 'BLCKTY20';
                }else if (cartOriginalGrandTotal >= 39 ) {
                    _customDiscountCode = 'BLCKTY15';
                } else {
                    _customDiscountCode = 'BLCKTY12';
                }

                setCookie('discount_code_origin', getCookie('discount_code'), 9999);
                setCookie('discount_code', _customDiscountCode, 9999);
                checkDiscountCodeBeforeRecomputeFinal();
                
            });
            withCustomCode = true;

        }



        // January 06, 2022
        var tempCodes = ['TYNY10','TYNY23'];
        if (tempCodes.indexOf(_customDiscountCode) !== -1) {

            $.getJSON('/cart.js', function (response) {
                
                cartOriginalGrandTotal = response.original_total_price / 100;
                cartOriginalGrandTotal = cartOriginalGrandTotal.toFixed(2);

                var _customDiscountCode = getCookie('discount_code'); // current code
                if (cartOriginalGrandTotal >= 69 ) {
                    _customDiscountCode = 'TYNY23';
                } else {
                    _customDiscountCode = 'TYNY10';
                }

                setCookie('discount_code_origin', getCookie('discount_code'), 9999);
                setCookie('discount_code', _customDiscountCode, 9999);
                checkDiscountCodeBeforeRecomputeFinal();
                
            });
            withCustomCode = true;

        }


        // February 02, 2023
        var tempCodes = ['14FORU','25UPHEART'];
        if (tempCodes.indexOf(_customDiscountCode) !== -1) {

            $.getJSON('/cart.js', function (response) {
                
                cartOriginalGrandTotal = response.original_total_price / 100;
                cartOriginalGrandTotal = cartOriginalGrandTotal.toFixed(2);

                var _customDiscountCode = getCookie('discount_code'); // current code
                if (cartOriginalGrandTotal >= 69 ) {
                    _customDiscountCode = '25UPHEART';
                } else {
                    _customDiscountCode = '14FORU';
                }

                setCookie('discount_code_origin', getCookie('discount_code'), 9999);
                setCookie('discount_code', _customDiscountCode, 9999);
                checkDiscountCodeBeforeRecomputeFinal();
                
            });
            withCustomCode = true;

        }


        // March 2023
        var tempCodes = ['INTLW10','INTLW15'];
        if (tempCodes.indexOf(_customDiscountCode) !== -1) {

            $.getJSON('/cart.js', function (response) {
                
                cartOriginalGrandTotal = response.original_total_price / 100;
                cartOriginalGrandTotal = cartOriginalGrandTotal.toFixed(2);

                var _customDiscountCode = getCookie('discount_code'); // current code
                if (cartOriginalGrandTotal >= 39 ) {
                    _customDiscountCode = 'INTLW15';
                } else {
                    _customDiscountCode = 'INTLW10';
                }

                setCookie('discount_code_origin', getCookie('discount_code'), 9999);
                setCookie('discount_code', _customDiscountCode, 9999);
                checkDiscountCodeBeforeRecomputeFinal();
                
            });
            withCustomCode = true;

        }

        // October 25, 2023
        var tempCodes = ['GHOUL10','BOO15','SCARED20'];
        if (tempCodes.indexOf(_customDiscountCode) !== -1) {

            $.getJSON('/cart.js', function (response) {
                
                cartOriginalGrandTotal = response.original_total_price / 100;
                cartOriginalGrandTotal = cartOriginalGrandTotal.toFixed(2);

                var _customDiscountCode = getCookie('discount_code'); // current code
                if (cartOriginalGrandTotal >= 100 ) {
                    _customDiscountCode = 'SCARED20';
                }else if (cartOriginalGrandTotal >= 50 ) {
                    _customDiscountCode = 'BOO15';
                } else {
                    _customDiscountCode = 'GHOUL10';
                }

                setCookie('discount_code_origin', getCookie('discount_code'), 9999);
                setCookie('discount_code', _customDiscountCode, 9999);
                checkDiscountCodeBeforeRecomputeFinal();
                
            });
            withCustomCode = true;

        }

        // CM 2023
        var tempCodes = ['CYBM15','CYBM25'];
        if (tempCodes.indexOf(_customDiscountCode) !== -1) {

            $.getJSON('/cart.js', function (response) {
                
                cartOriginalGrandTotal = response.original_total_price / 100;
                cartOriginalGrandTotal = cartOriginalGrandTotal.toFixed(2);

                var _customDiscountCode = getCookie('discount_code'); // current code
                if (cartOriginalGrandTotal >= 99 ) {
                    _customDiscountCode = 'CYBM25';
                } else {
                    _customDiscountCode = 'CYBM15';
                }

                setCookie('discount_code_origin', getCookie('discount_code'), 9999);
                setCookie('discount_code', _customDiscountCode, 9999);
                checkDiscountCodeBeforeRecomputeFinal();
                
            });
            withCustomCode = true;

        }


        // February 2024
        var tempCodes = ['LEAP10','LEAP12','LEAP15'];
        if (tempCodes.indexOf(_customDiscountCode) !== -1) {

            $.getJSON('/cart.js', function (response) {
                
                cartOriginalGrandTotal = response.original_total_price / 100;
                cartOriginalGrandTotal = cartOriginalGrandTotal.toFixed(2);

                var _customDiscountCode = getCookie('discount_code'); // current code
                if (cartOriginalGrandTotal >= 59 ) {
                    _customDiscountCode = 'LEAP15';
                }else if (cartOriginalGrandTotal >= 29 ) {
                    _customDiscountCode = 'LEAP12';
                } else {
                    _customDiscountCode = 'LEAP10';
                }

                setCookie('discount_code_origin', getCookie('discount_code'), 9999);
                setCookie('discount_code', _customDiscountCode, 9999);
                checkDiscountCodeBeforeRecomputeFinal();
                
            });
            withCustomCode = true;

        }


        // COACH10 COACH15 2024
        var tempCodes = ['COACH10','COACH15'];
        if (tempCodes.indexOf(_customDiscountCode) !== -1) {

            $.getJSON('/cart.js', function (response) {
                
                cartOriginalGrandTotal = response.original_total_price / 100;
                cartOriginalGrandTotal = cartOriginalGrandTotal.toFixed(2);


                // April 11, non USD
                var customGreaterEqualMax = 59;
                if (slShopify.currency.active !== 'USD'){
                    var slCurrencyRate = slShopify.currency.rate;
                    customGreaterEqualMax = customGreaterEqualMax * slCurrencyRate;
                }

                var _customDiscountCode = getCookie('discount_code'); // current code
                if (cartOriginalGrandTotal >= customGreaterEqualMax ) {
                    _customDiscountCode = 'COACH15';
                } else {
                    _customDiscountCode = 'COACH10';
                }

                setCookie('discount_code_origin', getCookie('discount_code'), 9999);
                setCookie('discount_code', _customDiscountCode, 9999);
                checkDiscountCodeBeforeRecomputeFinal();
                
            });
            withCustomCode = true;

        }


        // MIDYR10
        var tempCodes = ['MIDYR10','MIDYR15'];
        if (tempCodes.indexOf(_customDiscountCode) !== -1) {

            $.getJSON('/cart.js', function (response) {
                
                cartOriginalGrandTotal = response.original_total_price / 100;
                cartOriginalGrandTotal = cartOriginalGrandTotal.toFixed(2);


                // April 11, non USD
                var customGreaterEqualMax = 99;
                if (slShopify.currency.active !== 'USD'){
                    var slCurrencyRate = slShopify.currency.rate;
                    customGreaterEqualMax = customGreaterEqualMax * slCurrencyRate;
                }

                var _customDiscountCode = getCookie('discount_code'); // current code
                if (cartOriginalGrandTotal >= customGreaterEqualMax ) {
                    _customDiscountCode = 'MIDYR15';
                } else {
                    _customDiscountCode = 'MIDYR10';
                }

                setCookie('discount_code_origin', getCookie('discount_code'), 9999);
                setCookie('discount_code', _customDiscountCode, 9999);
                checkDiscountCodeBeforeRecomputeFinal();
                
            });
            withCustomCode = true;

        }


        if (!withCustomCode){
            checkDiscountCodeBeforeRecomputeFinal();
        }

        
    }

    function checkDiscountCodeBeforeRecomputeFinal(){

        $('.upsell-upgrade-offer').hide();


        var currentDiscountCodeTest = getCookie('discount_code');


        // October 2021 - HBD and REF5USD Excluded
        console.warn('REF5USD currentDiscountCodeTest',currentDiscountCodeTest);
        console.warn('REF5USD indexOf',currentDiscountCodeTest.indexOf('REF5USD-'));
        console.warn('REF5USD',(currentDiscountCodeTest.indexOf('REF5USD-') === -1));
  

        if ((getCookie('discount_code') != null || getCookie('discount_code') != "") && (currentDiscountCodeTest.indexOf('HBD-') === -1) && (currentDiscountCodeTest.indexOf('REF5USD-') === -1)) {

            console.warn('RECHECK DISCOUNT CODE APPLIED BEFORE RECOMPUTING...');

            
            var postData = {
                advanced_cart_discounts: 'init',
                discount_code: getCookie('discount_code')
            }
            var slAppURL = 'https://app.shinyleafcosmetics.com';
            $.get(slAppURL, postData, function (response) {

                DISCOUNT_CODE_DETAILS = undefined;
                advanceCartDiscountConditions = undefined;
                
                var $data = $.parseJSON(response);
                if ($data.status) {

                    DISCOUNT_CODE_DETAILS = $data;
                    advanceCartDiscountConditions = DISCOUNT_CODE_DETAILS.fields;
                    $('.upsell-upgrade-offer').show();
                    recomputeCart();

                }else{

                    // Code not in ACD
                    setCookie('discount_code_origin', getCookie('discount_code'), 9999);
                    setCookie('discount_code', 'DEFAULT10FX', 9999);
                    window.localStorage.removeItem('fixedPercentageRulesDEFAULT10FX');


                    var postData = {
                        advanced_cart_discounts: 'init',
                        discount_code: 'DEFAULT10FX'
                    }
                    
                    $.get(slAppURL, postData, function (response) {

                        DISCOUNT_CODE_DETAILS = undefined;
                        advanceCartDiscountConditions = undefined;
                        
                        var $data = $.parseJSON(response);
                        if ($data.status) {
                            DISCOUNT_CODE_DETAILS = $data;
                            advanceCartDiscountConditions = DISCOUNT_CODE_DETAILS.fields;
                        }
                        recomputeCart();
                    });


                }
                

            });
        
        }else{
            DISCOUNT_CODE_DETAILS = undefined;
            advanceCartDiscountConditions = undefined;
            recomputeCart();

            console.warn('NO CHECKING ANY DISCOUNT!!!');
        }
    }



    function setCookie(name,value,days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
    function eraseCookie(name) {   
        document.cookie = name+'=; Max-Age=-99999999;';  
    }




    function MD_initCustomQuantityDiscount() {

        var variantsCount = productSetVariantCount;
        var numberOfDiscounted = MD_numberOfDiscountedByQuantity(variantsCount);
        var text = '';
        var textStatus = '';
        $('.cart-generic-notes').remove();
        if (numberOfDiscounted >= 1) {

            if (numberOfDiscounted == 1) {
                text = '🎉Congratulations! Your <strong>2nd Shampoo and Conditioner Set is now 50% OFF</strong>. <br><small>(Discount will be reflected at the checkout page)</small>';
                textStatus = 'success';
            } else {
                text = '🎉 Amazing! Your <strong>other ' + numberOfDiscounted + ' Shampoo and Conditioner Sets are now 50% OFF</strong>. <br><small>(Discount will be reflected at the checkout page)</small>';
                textStatus = 'success';
            }

            $('.upsell-added-product .summary').prepend('<div class="cart-generic-notes cart-generic-success-notes">' + MD_unescapeHTML(text) + '</div>');
        } else {

            var realNumberOfDiscounted = variantsCount / 2;
            if (realNumberOfDiscounted == .5) {
                text = 'Hi! You need to add another <strong>Shampoo and Conditioner Set</strong> to <strong>get 50% OFF!</strong><br><a class="link-continue-shopping" href="https://www.shinyleaf.com/collections/shampoo-conditioner-sets">Continue shopping...</a>';
                textStatus = 'failed';
            } else {
                text = 'Hi! You need to add <strong>2 Shampoo and Conditioner Sets</strong> to <strong>get 50% OFF!</strong><br><a class="link-continue-shopping" href="https://www.shinyleaf.com/collections/shampoo-conditioner-sets">Continue shopping...</a>';
                textStatus = 'failed';
            }

            $('.upsell-added-product .summary').prepend('<div class="cart-generic-notes cart-generic-failed-notes">' + MD_unescapeHTML(text) + '</div>')
        }
    }
    function MD_unescapeHTML(str) {
        return str.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
    }
    function MD_numberOfDiscountedByQuantity(variantsCount) {
        return Math.floor(variantsCount / 2);
    }
    function MD_countVariants(variants) {
        var totalCount = 0;
        $.each(variants, function (index, variantID) {

            if ($('.cart-row-variant-' + variantID).length) {
                var currentVariant = $('.cart-row-variant-' + variantID);
                var currentVariantQuantity = currentVariant.find('.shinyleaf-update-line-item-quantity').val();
                currentVariantQuantity = parseInt(currentVariantQuantity);
                totalCount += currentVariantQuantity;
            }

        });
        return totalCount;
    }

    var upgradeDiscountValue = 0;
    function initDiscountCodeUpgradeRules(itemCount){

        console.warn('initDiscountCodeUpgradeRules()');

        $('.upgrade-discount-code').remove();
        upgradeDiscountValue = 0;

        console.warn('initDiscountCodeUpgradeRules()');
        if (advanceCartDiscountConditions !== null && advanceCartDiscountConditions.upgrade_status && advanceCartDiscountConditions.upgrade_rule_sets !== null && itemCount > 0) {
            
            $('.cart-generic-notes, .upsell-upgrade-offer').remove();

            console.warn('initDiscountCodeUpgradeRules() - Enabled');

            var ruleSets = advanceCartDiscountConditions.upgrade_rule_sets;


            var itemsQuantity = itemCount;

            var minimumRequirementType = advanceCartDiscountConditions.minimum_requirements;
            console.warn(minimumRequirementType);

            var discountType = advanceCartDiscountConditions.discount_type;
            var discountValue = 0;
            console.warn(discountType);

            var activeRuleSet = null;

            switch (discountType) {

                case 'percentage':


                    // Percentage + Min Requirements
                    switch (minimumRequirementType) {

                        case 'minimum_quantity_items':

                            console.warn('init minimum_quantity_items');

                            $.each(ruleSets, function (key, ruleSet) {

                                console.warn(ruleSet);

                                if (itemsQuantity >= ruleSet.min_quantity && itemsQuantity <= ruleSet.max_quantity) {
                                    activeRuleSet = ruleSet;
                                    console.warn('RULE SET MATCHED');
                                } else {
                                    console.warn('RULE SET NOT MATCHED');
                                }

                            });

                            break;

                        case 'minimum_purchase_amount':

                            console.warn('init minimum_purchase_amount');
                            console.warn(ruleSets);

                            $.each(ruleSets, function (key, ruleSet) {

                                console.warn(ruleSet);

                                if (cartOriginalGrandTotal >= ruleSet.min_purchase && cartOriginalGrandTotal <= ruleSet.max_purchase) {
                                    activeRuleSet = ruleSet;
                                }

                            });

                            break;

                    }

                    break;


                case 'fixed':
                    discountValue = advanceCartDiscountConditions.discount_value_fixed_amount;
                    break;

            }



            /*
            * Rule Set - Process it!
            * rule set is set - we need process right away
            */

            if (activeRuleSet) {
                console.warn('activeRuleSet');
                console.warn(activeRuleSet);

                switch (discountType) {

                    case 'percentage':

                        var cartDiscountValue = activeRuleSet.discount_value / 100;
                        var newCartTotal = cartOriginalGrandTotal - (cartOriginalGrandTotal * cartDiscountValue);
                        handleCartTotal(newCartTotal.toFixed(2));

                        discountValueOneTime = cartDiscountValue;
                        applyUpsellProductsPriceDiscount();
                        
                    break;

                }

                var successNotes = activeRuleSet.success_notes;
                $('.upsell-added-product .summary').prepend('<div class="zoom-in-out-box cart-generic-notes cart-generic-success-notes">' + MD_unescapeHTML(successNotes) + '</div>');

                if (activeRuleSet.notes != '') {

                    var upsellProductHTML = '';
                    upsellProductHTML += '<div class="upsell-upgrade-offer">';
                    upsellProductHTML += MD_unescapeHTML(activeRuleSet.notes);
                    upsellProductHTML += '</div>';
                    $('.upsell-added-product').after(upsellProductHTML);
                }

                // upgradeDiscountCode = activeRuleSet.discount_code;


            } else {
                console.warn('No active rule set!');
                var upsellProductHTML = '';
                upsellProductHTML += '<div class="upsell-upgrade-offer">';
                upsellProductHTML += MD_unescapeHTML(advanceCartDiscountConditions.upgrade_default_notes);
                upsellProductHTML += '</div>';

                if (advanceCartDiscountConditions.minimum_requirements_success_notes_for_upsell_cart){
                    $('.upsell-added-product .summary').prepend('<div class="cart-generic-notes cart-generic-success-notes">' + MD_unescapeHTML(advanceCartDiscountConditions.minimum_requirements_success_notes_for_upsell_cart) + '</div>');
                    
                    var cartDiscountValue = advanceCartDiscountConditions.discount_value_percentage / 100;
                    var newCartTotal = cartOriginalGrandTotal - (cartOriginalGrandTotal * cartDiscountValue);
                    handleCartTotal(newCartTotal.toFixed(2));

                }

                $('.upsell-added-product').after(upsellProductHTML);

            }


        } else {
            console.warn('initDiscountCodeUpgradeRules() - Disabled');
        }
    }


    /*
    * Name: Buy X Get Y
    * Description:  Module for Buy X Get Y
    * Version: 1.0.0
    * Created At: 2020-03-19
    * Updated At: 2020-03-19
    */
    var buyXGetYModule = {
        isCartPage: false,
        rule: null,
        totalLineItemQuantity: 0,
        cartLineItems : null,
        init: function (discountCode, cartLineItems) {

            this.cartLineItems = cartLineItems;
            console.warn('[buyXGetYModule] Discount Code = ' + discountCode);

            // Reset Rule
            this.rule = null;

            // Check If Cart Page
            if ($('.template-cart').length) {
                this.isCartPage = true;
            }

            console.warn(this.checkDiscountCode(discountCode));
            if (this.checkDiscountCode(discountCode)) {

                // Let Check What We Have
                switch (discountCode) {

                    case 'AFTERPAYDAYXXX':

                        this.rule = {
                            'required_variants': [31676552511620, 7327549521979],
                            'requirement_type': 'quantity',
                            'min': 1,
                            'max': 9999,
                            'failed_notes': 'Hi! Add a <strong>Tea Tree Shampoo or Tea Tree Conditioner </strong> and <strong>get 70% OFF</strong> on your chosen product!<br><a class="link-continue-shopping" href="https://www.shinyleaf.com/discount/AFTERPAYDAY?redirect=%2Fpages%2Fpromotions-afterpayday-2020-70-off"> Continue shopping...</a>',
                            'success_notes': '🎉Congratulations! Your <strong>chosen tea tree oil product is now 70% OFF</strong>. <br><small>(Discount will be reflected at the checkout page)'
                        }

                        break;

                }

                console.warn('[buyXGetYModule] Rule');
                console.warn(this.rule);
                if (this.rule) {
                    this.process();
                }


            }

        },
        process: function () {

            this.clearNotes();

            var variantsCount = this.countVariants(this.rule.required_variants);
            console.warn('[buyXGetYModule] variantsCount = ' + variantsCount);


            console.warn('[buyXGetYModule] totalLineItemQuantity = ' + totalLineItemQuantity);

            var numberOfDiscounted = Math.floor(variantsCount / 2);
            var successNotes = this.unescapeHTML(this.rule.success_notes);
            var failedNotes = this.unescapeHTML(this.rule.failed_notes);

            if (variantsCount >= this.rule.min && variantsCount <= this.rule.max) {

                if (totalLineItemQuantity > this.rule.min) {
                    $('#shinyleaf-cart-page h1').after('<div class="cart-generic-notes cart-generic-success-notes">' + successNotes + '</div>');
                    $('.upsell-added-product .summary').prepend('<div class="cart-generic-notes cart-generic-success-notes">' + successNotes + '</div>');
                    $('.upsell-mobile-only').html('<div class="cart-generic-notes cart-generic-success-notes">' + successNotes + '</div>');


                } else {

                    var optionalNotes = 'Hi! Please add at least 1 regular-priced item!<br><a class="link-continue-shopping" href="https://www.shinyleaf.com/collections/all"> Continue shopping...</a>'
                    var failedNotes = this.unescapeHTML(optionalNotes);

                    $('#shinyleaf-cart-page h1').after('<div class="cart-generic-notes cart-generic-failed-notes">' + failedNotes + '</div>');
                    $('.upsell-added-product .summary').prepend('<div class="cart-generic-notes cart-generic-failed-notes">' + failedNotes + '</div>');
                    $('.upsell-mobile-only').html('<div class="cart-generic-notes cart-generic-failed-notes">' + failedNotes + '</div>');
                }

            } else {
                $('#shinyleaf-cart-page h1').after('<div class="cart-generic-notes cart-generic-failed-notes">' + failedNotes + '</div>');
                $('.upsell-added-product .summary').prepend('<div class="cart-generic-notes cart-generic-failed-notes">' + failedNotes + '</div>');
                $('.upsell-mobile-only').html('<div class="cart-generic-notes cart-generic-failed-notes">' + failedNotes + '</div>');
            }

        },
        clearNotes: function () {
            $('.cart-generic-notes').remove();
            $('.cart-generic-notes').remove();
            $('.upsell-mobile-only').html('');
        },
        countVariants: function (variants) {

            var totalCount = 0;

            if (this.isCartPage) {

                $.each(variants, function (index, variantID) {

                    if ($('.cart-row-variant-' + variantID).length) {
                        var currentVariant = $('.cart-row-variant-' + variantID);
                        var currentVariantQuantity = currentVariant.find('.shinyleaf-update-line-item-quantity').val();
                        currentVariantQuantity = parseInt(currentVariantQuantity);
                        totalCount += currentVariantQuantity;
                    } else {

                    }

                });

            } else {
                console.warn('this.cartLineItems');
                $.each(this.cartLineItems, function (index, lineItem) {
                    if (variants.indexOf(lineItem.id) > -1){
                        var currentVariantQuantity = lineItem.quantity;
                        totalCount += currentVariantQuantity;
                    }
                });

            }


            return totalCount;

        },
        checkDiscountCode: function (discountCode) {

            if (typeof discountCode !== 'undefined' && discountCode !== null && discountCode !== '') {
                return true;
            } else {
                return false;
            }

        },
        unescapeHTML: function (str) {
            return str.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
        }
    };

});